
















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {STreeItem} from "@/components/dto/STreeItem";
import {SItemTypeEnum} from "@/components/dto/SItemTypeEnum";
import TreeItem from "@/components/TreeItem.vue";
import Tree from "@/components/Tree.vue";
import {SPropTypeEnum} from "@/components/dto/SPropTypeEnum";
import {STreeData} from "@/components/dto/STreeData";

@Component({
  components: {Tree, TreeItem}
})
export default class XmlTreeItem extends Vue {
  @Prop() item!: STreeItem;
  @Prop({default: false}) readonly!: boolean;
  private isFolder: boolean = false;
  private modelOpen: boolean = false;
  private xmlItemType: SItemTypeEnum = SItemTypeEnum.XML;
  private SOBJECT: SPropTypeEnum = SPropTypeEnum.SOBJECT;

  created(){
    this.isFolder = this.folder();
    this.modelOpen = this.item.isOpen;
  }

  watchModelAllGenerated(newValue: boolean){

  }

  treeData(children: STreeItem[]){
    let trees : STreeData = {type: SPropTypeEnum.SNULL, treeItems: []};
    trees.treeItems.push(...children);
    return trees;
  }

  get collapseItem(){
    return ((this.item.isOpen && !this.readonly) || (this.item.allGenerated && this.readonly));
  }

  set collapseItem(val: boolean){}

  toggleItem(){
    if(this.isFolder && !this.readonly){
      this.item.isOpen = !this.item.isOpen;
    }
  }
  folder(){
    if(this.item.propChildren.length > 1){
      return true;
    }else{
      return this.item.propChildren.filter(i => i.propName || i.propOutputType === SPropTypeEnum.SOBJECT).length === 1;
    }
    return false;
  }
  getPropValue(item: STreeItem){
    if(item.propChildren.length === 0){
      return item.propValue;
    }else if(item.propChildren.length === 1){
      return item.propChildren[0].propValue;
    }
  }

  @Watch( 'item.isOpen')
  watchisOpen(newValue: boolean){
    if(newValue || (this.item.allGenerated && this.readonly)){
      this.modelOpen = newValue;
    }else {
      this.modelOpen = false;
    }
  }

}
